import { initializeFaro, getWebInstrumentations } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { getSubdomain, getEnvType } from './helpers/helper';

let faro = null;

// What a URL can carry that must not leave the browser: one-time link tokens
// (confirm, reset), a Google sign-in's one-time code or bearer token, an
// activation token, an address.
const SECRET_PARAMS = ['token', 'code', 'access_token', 'activation_token', 'email'];
const SECRET_PARAM = new RegExp(`([?&#](?:${SECRET_PARAMS.join('|')})=)[^&#\\s"']*`, 'gi');

/** Faro sends page URLs; a one-time token or an address in one must not leave the browser. */
export function scrubSecrets(item) {
  const walk = (v) => {
    if (typeof v === 'string') return v.replace(SECRET_PARAM, '$1[redacted]');
    if (Array.isArray(v)) return v.map(walk);
    if (v && typeof v === 'object') {
      return Object.fromEntries(Object.entries(v).map(([k, x]) => [k, walk(x)]));
    }
    return v;
  };
  return walk(item);
}

export function initFaro() {
  if (faro) return faro;

  const url = import.meta.env.VITE_FARO_URL;
  if (!url) return null;

  faro = initializeFaro({
    url,
    app: {
      name: 'hub',
      version: import.meta.env.VITE_APP_VERSION || '1.0.0',
      environment: getEnvType() || 'development',
      namespace: getSubdomain(),
    },
    beforeSend: scrubSecrets,
    instrumentations: [
      ...getWebInstrumentations({ captureConsole: false }),
      new TracingInstrumentation(),
    ],
  });

  return faro;
}

/** A failure worth knowing about: the console, and Faro when it is running. */
export function reportError(error) {
  console.error(error);
  faro?.api?.pushError(error instanceof Error ? error : new Error(String(error)));
}
